import * as S from './PanelError.styles';
import React from 'react';
import WBIcon from './WBIcon';
import makeComp from '../../util/profiler';

const PanelError = makeComp(
  (props: {message: React.ReactChild; className?: string}) => {
    return (
      <div className={`panel-error ${props.className || ''}`}>
        <div>
          <S.IconWrapper>
            <WBIcon name="info" />
          </S.IconWrapper>
          <div>{props.message}</div>
        </div>
      </div>
    );
  },
  {id: 'PanelError'}
);
export default PanelError;
